import { render, staticRenderFns } from "./OverviewBarCard.vue?vue&type=template&id=25bab004&scoped=true"
import script from "./OverviewBarCard.vue?vue&type=script&lang=js"
export * from "./OverviewBarCard.vue?vue&type=script&lang=js"
import style0 from "./OverviewBarCard.vue?vue&type=style&index=0&id=25bab004&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25bab004",
  null
  
)

export default component.exports